import { Button } from "../../../components/Button";

export function Banner({ playlist, onDelete }) {
  return (
    <div>
      <div className="w-[898px] mb-6 p-5 rounded-[16px] shadow-[0px_0px_10px_0px_rgba(0,0,0,0.10)] bg-white justify-start items-stretch gap-3 flex relative">
        <div className="h-[100px] w-20 rounded-md">
          <img
            src={playlist?.playlist_image || "/profile.jpeg"}
            className="w-full h-full rounded-md object-fill"
            alt="playlist"
          />
        </div>
        <div className="flex-1">
          <div className="flex-col justify-start items-start gap-2 flex">
            <div className="justify-start items-center gap-2 flex">
              <div className="text-black text-lg font-bold">
                {playlist?.playlist_title}
              </div>
            </div>

            <div className="justify-center items-center gap-2 inline-flex">
              <div className="h-[26px] px-2 py-1 text-center text-black text-[13px] font-medium font-['Montserrat'] leading-[18.20px] bg-[#f8f8f8] rounded border border-[#414949]/10 justify-center items-center gap-2.5 inline-flex">
                Total Courses :{playlist?.videos?.length} Courses
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end justify-between">
          <div className="flex justify-between">
            <div className="items-center gap-4 flex">
              <Button
                variant="link"
                className="text-right !text-[#d54949] text-sm font-medium poppins"
                onClick={onDelete}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
